import Vue from "vue";
import axios from "axios";

const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term, descCol) => {
  if (term) {
    return items.filter((item) =>
      toLower(item[descCol]).includes(toLower(term))
    );
  }

  return items;
};

export default {
  name: "reports",
  props: {
    reportsList: {
      type: Array,
      required: true,
    },
    reportIdField: {
      type: String,
      default: "reportId",
    },
    reportDescriptionField: {
      type: String,
      default: "description",
    },
    reportLink: {
      type: String,
    },
    reportLinkFunction: {
      type: Function,
    },
    title: {
      type: String,
      default: "reports",
    },
    queries: {
      type: Array,
      default: () => [],
      //required: true
    },
  },
  data: function () {
    return {
      search: null,
      searched: [],
      selectedQueryKey: "",
      reportDescriptionFieldreportDescriptionField: null,
    };
  },
  created() {
    this.searched = this.reportsList;

    if (this.queries.length > 0) {
      this.selectedQueryKey = this.queries[0].key;
    }
  },
  methods: {
    searchOnTable() {
      this.searched = searchByName(
        this.reportsList,
        this.search,
        this.reportDescriptionField
      );
    },
    printReport(reportId) {
      if (this.reportLinkFunction != null) {
        this.reportLinkFunction(reportId);
      } else {
        axios
          .post(this.reportLink + reportId)
          .then((response) => {
            if (response.status == 200) {
              window.open(response.data, "_blank");
            } else this.$alertMsg(response.data.data.text);
          })
          .catch((err) =>
            err.data == undefined
              ? this.$alertMsg(
                  `${this.$t("messages.apiRespondedWithCode")} ${
                    err.response.status
                  }`
                )
              : this.$alertMsg(err.data.data.text)
          );
      }
    },
    runQuery(queryId) {
      window.open("/queryViewer/" + queryId, "_blank");
    },
  },
};
